import React, {useEffect, useState} from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';

const AdditionalDetailsStep: React.FC<StepComponentProps> = ({
                                                               formData,
                                                               updateFormData,
                                                               onNext,
                                                               onPrevious,
                                                               canGoBack,
                                                               canGoNext,
                                                               patientCaseType,
                                                               journey,
                                                               onSave,
                                                               updating,
                                                             }) => {
  const [additionalDetails, setAdditionalDetails] = useState<string>(formData.additionalDetails || '');

  useEffect(() => {
    updateFormData({additionalDetails});
  }, [additionalDetails]);

  const handleSubmit = (event: any, values: any) => {
    // This is the final step, so we save the data
    const finalFormData = {
      ...formData,
      additionalDetails,
    };

    if (onSave) {
      onSave(finalFormData);
    }
  };

  const handleDetailsChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAdditionalDetails(event.target.value);
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="mb-4">Please add additional details (If applicable)</h6>
        <AvForm onValidSubmit={handleSubmit}>
          <Row>
            <Col md="12">
              <AvGroup>
                <Label for="additionalDetails">Additional Details</Label>
                <AvInput
                  type="textarea"
                  name="additionalDetails"
                  id="additionalDetails"
                  value={additionalDetails}
                  onChange={handleDetailsChange}
                  placeholder="Please specify"
                  rows={6}
                  style={{resize: 'vertical', minHeight: '150px'}}
                />
              </AvGroup>
            </Col>
          </Row>

          <FollowupButtons
            currentStep={11}
            totalSteps={11}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
            isLastStep={true}
            updating={updating}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default AdditionalDetailsStep;
